// src/components/TopServices.js
import React from 'react';
import './TopServices.css';

function TopServices() {
  return (
    <section className="top-services">
      <div className="top-services-content">
        <h2 className="services-heading">Discover Our Top Services</h2>
        <p className="services-subheading">Experience consultancy like never before</p>

        <div className="services-grid">
          {/* Courier Services */}
          <div className="service-card">
            <h3>Courier Services</h3>
            <p>Swift and reliable shipping solutions worldwide.</p>
            <a href="/courier/book" className="service-link">Learn more</a>
          </div>

          {/* Visa Assistance */}
          <div className="service-card">
            <h3>Visa Assistance</h3>
            <p>Hassle-free guidance for global travel and business.</p>
            <a href="/visa" className="service-link">Learn more</a>
          </div>

          {/* Attestation Services */}
          <div className="service-card">
            <h3>Attestation Services</h3>
            <p>Secure and verified documentation at your fingertips.</p>
            <a href="/attestation" className="service-link">Learn more</a>
          </div>

          {/* IT Services */}
          <div className="service-card">
            <h3>IT Services</h3>
            <p>Innovative tech solutions to power your business growth.</p>
            <a href="/it" className="service-link">Learn more</a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TopServices;
